import { ref, watch } from '@vue/composition-api'
import { fetchTodayMatches, fetchTodayMatchesCount } from '@ms/api/match'
import useCreateMatches from '@ms/components/match/useCreateMatches.js'

export default function useToday() {
  const { matches: todayMatches, resetMatches, setMatches } = useCreateMatches()

  // today matches count, -1 代表未请求过
  const todayMatchesCount = ref(-1)

  // 设置 today matches list & count
  const setTodayMatches = ({ events = [], matchesCount = 0 }) => {
    setMatches(events)
    todayMatchesCount.value = matchesCount
  }

  const resetTodayCount = () => {
    todayMatchesCount.value = -1
  }

  const resetTodayMatches = () => {
    resetMatches()
    resetTodayCount()
  }

  const setTodayMatchesCount = (count = 0) => {
    todayMatchesCount.value = count
  }

  // 获取今日足球比赛
  async function getTodayMatches(sportId = '') {
    const { error, data } = await fetchTodayMatches(sportId)
    if (error) {
      return Promise.reject(error)
    } else {
      setTodayMatches(data)
    }
  }

  // 获取今日足球比赛数量
  async function getTodayMatchesCount(sportId = '') {
    const { error, data } = await fetchTodayMatchesCount(sportId)
    if (!error) {
      setTodayMatchesCount(data.count)
    }
  }

  watch(
    () => todayMatches.value.length,
    (count, prevCount) => {
      if (prevCount && prevCount === todayMatchesCount.value) {
        setTodayMatchesCount(count)
      }
    }
  )

  return {
    todayMatches,
    todayMatchesCount,
    resetTodayCount,
    resetTodayMatches,
    getTodayMatches,
    getTodayMatchesCount
  }
}
